module.exports = __webpack_public_path__ + "img/mock_exam.0531b646.png";